import styled, { keyframes } from 'styled-components'

// Spinner de busca (evento/produtor) — sinaliza "buscando" em toda pesquisa.
const spin = keyframes`
  to { transform: rotate(360deg); }
`
export const SearchWrap = styled.div`
  position: relative;
`
export const SearchSpinner = styled.span`
  position: absolute;
  right: 14px;
  top: 50%;
  width: 16px;
  height: 16px;
  margin-top: -8px;
  border: 2px solid #eaecf0;
  border-top-color: #b0020b;
  border-radius: 50%;
  animation: ${spin} 0.7s linear infinite;
  pointer-events: none;
`

// Overlay de carregamento da página (ao Filtrar / trocar seleção enquanto busca).
export const LoadingOverlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(255, 255, 255, 0.62);
  backdrop-filter: blur(1px);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
`
export const BigSpinner = styled.span`
  width: 42px;
  height: 42px;
  border: 4px solid #eaecf0;
  border-top-color: #b0020b;
  border-radius: 50%;
  animation: ${spin} 0.9s linear infinite;
`
// Logo BD espelhando — mesmo padrão do loading do Borderô (Pages/Bordero).
const flip = keyframes`
  from { transform: rotateY(0deg); }
  to { transform: rotateY(360deg); }
`
export const SpinLogo = styled.img`
  width: 52px;
  height: 52px;
  animation: ${flip} 1.6s ease-in-out infinite;
`
export const LoadingText = styled.span`
  font-family: 'Inter', sans-serif;
  font-size: 14px;
  font-weight: 600;
  color: #616161;
  min-height: 20px;
`

// Séries no design system BD: base = BD Digital Red (#B0020B, cor de UI/destaque —
// o #E9030F é só logo), comparado = Text Primary (#212121). Neutros na escala BD.
export const SERIES_BASE = '#B0020B'
export const SERIES_COMPARE = '#212121'

// neutros (Untitled UI, iguais aos dos cards analíticos existentes)
const INK = '#212121'
const MUTED = '#555555'
const FAINT = '#B0B0B0'
const BORDER = '#EAECF0'
const SURFACE_2 = '#F9F9F9'
const GOOD = '#067647'
const GOOD_BG = '#ECFDF3'
const BAD = '#B42318'
const BAD_BG = '#FEF3F2'

export const Page = styled.div`
  flex: 1;
  padding: 24px 32px 64px;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  @media (max-width: 720px) {
    padding: 16px;
  }
`

export const PageTitle = styled.h1`
  font-size: 22px;
  font-weight: 700;
  color: ${INK};
  margin: 0 0 4px;
`

export const PageSub = styled.p`
  font-size: 14px;
  color: ${MUTED};
  margin: 0 0 20px;
`

export const EntryTabs = styled.div`
  display: inline-flex;
  gap: 4px;
  background: ${SURFACE_2};
  border: 1px solid ${BORDER};
  border-radius: 10px;
  padding: 3px;
  margin-bottom: 16px;
`

export const EntryTab = styled.button<{ $active: boolean }>`
  border: 0;
  background: ${(p) => (p.$active ? '#fff' : 'transparent')};
  color: ${(p) => (p.$active ? INK : MUTED)};
  box-shadow: ${(p) => (p.$active ? '0 1px 2px rgba(16,24,40,.1)' : 'none')};
  font-size: 13px;
  font-weight: 560;
  padding: 7px 14px;
  border-radius: 7px;
  cursor: pointer;
`

export const FiltersCard = styled.div`
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1), 0 1px 2px rgba(16, 24, 40, 0.06);
  padding: 16px;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  margin-bottom: 20px;
  @media (max-width: 720px) {
    grid-template-columns: 1fr;
  }
`

export const FilterField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`

export const FieldLabel = styled.label`
  font-size: 11px;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: ${FAINT};
  font-weight: 640;
`

export const ControlsRow = styled.div`
  grid-column: 1 / -1;
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
  border-top: 1px dashed ${BORDER};
  padding-top: 14px;
`

export const PeriodSeg = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  background: ${SURFACE_2};
  border: 1px solid ${BORDER};
  border-radius: 10px;
  padding: 3px;
`

export const PeriodBtn = styled.button<{ $active: boolean }>`
  border: 0;
  background: ${(p) => (p.$active ? SERIES_BASE : 'transparent')};
  color: ${(p) => (p.$active ? '#fff' : MUTED)};
  font-size: 12.5px;
  font-weight: 560;
  padding: 6px 12px;
  border-radius: 7px;
  cursor: pointer;
`

export const Legend = styled.div`
  margin-left: auto;
  display: flex;
  gap: 16px;
  align-items: center;
  font-size: 12.5px;
  color: ${MUTED};
`

export const LegendItem = styled.span`
  display: flex;
  gap: 7px;
  align-items: center;
`

export const Dot = styled.span<{ $color: string }>`
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: ${(p) => p.$color};
  flex: none;
`

export const KpiRow = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 16px;
  margin-bottom: 24px;
  @media (max-width: 720px) {
    grid-template-columns: repeat(2, 1fr);
  }
`

export const KpiCard = styled.div`
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1), 0 1px 2px rgba(16, 24, 40, 0.06);
  padding: 16px;
`

export const KpiLabel = styled.div`
  font-size: 12px;
  color: ${MUTED};
  font-weight: 560;
`

export const KpiVals = styled.div`
  display: flex;
  align-items: baseline;
  gap: 8px;
  margin-top: 10px;
  flex-wrap: wrap;
  font-variant-numeric: tabular-nums;
`

export const KpiA = styled.span`
  font-size: 21px;
  font-weight: 720;
  color: ${SERIES_BASE};
  letter-spacing: -0.02em;
`

export const KpiVs = styled.span`
  color: ${FAINT};
  font-size: 12px;
`

export const KpiB = styled.span`
  font-size: 15px;
  font-weight: 640;
  color: ${SERIES_COMPARE};
`

export const Delta = styled.span<{ $up: boolean }>`
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 660;
  padding: 3px 8px;
  border-radius: 20px;
  margin-top: 10px;
  color: ${(p) => (p.$up ? GOOD : BAD)};
  background: ${(p) => (p.$up ? GOOD_BG : BAD_BG)};
`

export const SectionTitle = styled.h2`
  font-size: 15px;
  font-weight: 680;
  color: ${INK};
  margin: 0 0 12px;
`

export const ChartBox = styled.div`
  height: 340px;
  @media (max-width: 720px) {
    height: 260px;
  }
`

export const MiniSeg = styled.div`
  display: inline-flex;
  background: ${SURFACE_2};
  border: 1px solid ${BORDER};
  border-radius: 9px;
  padding: 3px;
`

export const MiniBtn = styled.button<{ $active: boolean }>`
  border: 0;
  background: ${(p) => (p.$active ? '#fff' : 'transparent')};
  color: ${(p) => (p.$active ? INK : MUTED)};
  box-shadow: ${(p) => (p.$active ? '0 1px 2px rgba(16,24,40,.1)' : 'none')};
  font-size: 12px;
  font-weight: 560;
  padding: 5px 11px;
  border-radius: 6px;
  cursor: pointer;
`

export const TableScroll = styled.div`
  overflow-x: auto;
  background: #fff;
  border: 1px solid ${BORDER};
  border-radius: 14px;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.1), 0 1px 2px rgba(16, 24, 40, 0.06);
  padding: 8px 4px;
`

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;
  font-size: 13px;
  font-variant-numeric: tabular-nums;

  th,
  td {
    padding: 9px 14px;
    text-align: right;
    white-space: nowrap;
  }
  th:first-child,
  td:first-child {
    text-align: left;
  }
  thead th {
    font-size: 11px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    color: ${FAINT};
    font-weight: 640;
    border-bottom: 1px solid ${BORDER};
  }
  tbody td {
    border-bottom: 1px solid ${BORDER};
    color: ${INK};
  }
  tbody tr:hover {
    background: ${SURFACE_2};
  }
`

export const DeltaCell = styled.span<{ $up: boolean }>`
  font-weight: 640;
  font-size: 12px;
  color: ${(p) => (p.$up ? GOOD : BAD)};
`
